/* eslint-disable no-restricted-syntax */
import { TProductFilters } from 'api/types';

export const fromObjectToQueryString = (
  params: Record<string, unknown>,
  prefix?: string
): string => {
  console.log(params);
  if (!params || typeof params !== 'object') return '';

  const queryParts: string[] = [];

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;

    const fullKey = prefix ? `${prefix}[${key}]` : key;

    // Nested object
    if (typeof value === 'object' && !Array.isArray(value)) {
      const nested = fromObjectToQueryString(
        value as Record<string, unknown>,
        fullKey
      );
      if (nested) queryParts.push(nested.replace(/^\?/, '')); // strip leading ?
      continue;
    }

    // Array
    if (Array.isArray(value)) {
      value.forEach((v) => {
        queryParts.push(
          `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(v))}`
        );
      });
      continue;
    }

    // Primitive
    queryParts.push(
      `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`
    );
  }

  const query = queryParts.join('&');
  return prefix ? query : query ? `?${query}` : '';
};

export const objectToFormData = (obj, form = null, namespace = '') => {
  const formData = form || new FormData();

  for (const property in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (!obj.hasOwnProperty(property) || obj[property] === undefined) continue;

    const formKey = namespace ? `${namespace}[${property}]` : property;
    const value = obj[property];

    if (value instanceof File || value instanceof Blob) {
      // Append file / blob directly
      formData.append(formKey, value);
    } else if (Array.isArray(value)) {
      // Handle arrays
      value.forEach((item, index) => {
        if (item instanceof File || item instanceof Blob) {
          formData.append(`${formKey}`, item);
        } else if (typeof item === 'object') {
          // Nested objects in array
          objectToFormData(item, formData, `${formKey}[${index}]`);
        } else {
          formData.append(`${formKey}[]`, item);
        }
      });
    } else if (typeof value === 'object' && value !== null) {
      // Nested object
      objectToFormData(value, formData, formKey);
    } else {
      // Primitive value
      formData.append(formKey, value);
    }
  }

  return formData;
};

export const cleanFilters = (filters: TProductFilters) => {
  const cleanedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
    // Skip empty arrays
    if (Array.isArray(value) && value.length === 0) {
      return acc;
    }
    // Skip empty objects
    if (
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value) &&
      Object.keys(value).length === 0
    ) {
      return acc;
    }
    // Keep all other values
    acc[key] = value;
    return acc;
  }, {} as TProductFilters);
  return cleanedFilters;
};
